// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoCancelRequestQueue } from './po-cancel-request-queue';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Email extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** String(50) */
  entityId?: string;
  /** String(50) */
  entityTypeName?: string;
  /** String(255) */
  messageId!: string;
  /** String(20) */
  status!: string;
  /** DateTimeOffset */
  statusTs?: Date;
  /** String(255) */
  toAddress!: string;
  /** Inv FK emailId */
  poCancelRequestQueues!: PoCancelRequestQueue[];
}

